import React, { FunctionComponent, ReactElement, ReactNode, useCallback } from "react";
import CartRadioInput from "@Components/atoms/cart/CartRadioInput";
import "./style.scss";

interface Props {
  checked: boolean;
  children: ReactNode;
  disabled?: boolean;
  name: string;
  onChange: (name: string) => void;
  value: string;
}

const CartRadioInputWithLabel: FunctionComponent<Props> = ({
  children,
  value,
  name,
  onChange,
  checked = false,
}): ReactElement => {
  const handleChange = useCallback(onChange, [onChange, value]);

  const handleClick = () => {
    onChange(value);
  };

  return (
    <div className="CartRadioInputWithLabel" onClick={handleClick}>
      <CartRadioInput checked={checked} name={name} onChange={handleChange} value={value} />
      <div className="CartRadioInputWithLabel-info">{children}</div>
    </div>
  );
};

export default CartRadioInputWithLabel;
